export default __webpack_public_path__ + "static/media/Resistance2Img.0f463218.jpg";